import { motion } from "framer-motion";

const itemVariants = {
  hidden: { opacity: 0, y: 15 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
};

export const FormInput = ({
  label,
  name,
  type = "text",
  placeholder,
  value,
  onChange,
}) => (
  <motion.div variants={itemVariants}>
    <label
      htmlFor={name}
      className="block text-sm font-medium text-gray-200 mb-2"
    >
      {label}
    </label>
    <input
      id={name}
      name={name}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className="w-full px-4 py-3 bg-transparent text-white border border-slate-600 rounded-lg placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      required
    />
  </motion.div>
);
